import styled, { css } from 'styled-components'
import { layout, typography } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

const shouldForwardProp = prop => {
  return !['light', 'justifyContent'].includes(String(prop))
}

export const Container = styled(Flex).withConfig({
  shouldForwardProp,
})`
  width: 100%;
  padding: 0;
  margin-bottom: 12px;
  align-items: center;
`

const iconLightBgCss = ({ light }) =>
  light &&
  css`
    background-color: ${themeGet('colors.ultramarineBlue')};
  `

export const IconBg = styled.div.withConfig({
  shouldForwardProp,
})`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background-color: ${themeGet('colors.calculator.selected')};
  border-radius: 50%;
  fill: ${themeGet('colors.calculator.action')};

  ${layout};

  ${iconLightBgCss}
`

const tagTextLightCss = ({ light }) =>
  light &&
  css`
    color: ${themeGet('colors.white')};
  `

export const TagText = styled.span.withConfig({
  shouldForwardProp,
})`
  color: ${themeGet('colors.calculator.action')};
  text-transform: uppercase;
  font-weight: 700;

  ${typography};

  ${tagTextLightCss}
`
